import React from 'react';
import { Form, Select } from 'antd';
import { useReadOnly } from '@spark';
const { Option } = Select;

export default function StatusEdit(props) {
    const { readOnly } = useReadOnly();
    let options = []
    if (props.record[props.dataIndex] === "running") {
        options = ["running", "paused"]
    } else if (props.record[props.dataIndex] === "waiting") {
        options = ["waiting", "paused"]
    } else if (props.record[props.dataIndex] === "paused") {
        options = ["paused", "waiting"]
    }
    return (
        <Form.Item
            style={{
                margin: 0,
            }}
            name={props.dataIndex}
        >
            <Select
                placeholder="Select Status"
                disabled={readOnly}
                onChange={props.save}
                onPressEnter={props.save}
                onBlur={props.save}>
                {
                    options.map((value) => ( // Use map to iterate through values array
                        <Option key={value} value={value}>{value.toUpperCase()}</Option>
                    ))
                }
            </Select>
        </Form.Item>
    );
};

